import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../../../app/shared/_services/storage.service';
import { HeaderService } from '../../../../app/shared/_services/header.service';
import { MetaService } from '@ngx-meta/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { ApiService } from '../../../../app/shared/_services/api.service';
import { CarrelloService } from '../../.../../../../app/shared/_services/carrello.service';

@Component({
  selector: 'app-pagamento-annullato',
  templateUrl: './pagamento-annullato.component.html',
  styles: []
})
export class PagamentoAnnullatoComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private localize: LocalizeRouterService,
    private carrelloService: CarrelloService,
    private meta: MetaService
    ) { }

  ngOnInit() {
    this.meta.setTag('robots', 'noindex');
    this.route.queryParams.subscribe(params => {
      console.log(params);
      if (params) {
        const jsonIn = {
          token: params.token,
          numOrdine: params.NO,
          numTransazione: params.NT,
          errorCode: params.Err,
          language: this.localize.parser.currentLang.toUpperCase()
        };
        this.api.ordinePagato(jsonIn).subscribe(() => this.carrelloService.aggiornaCarrello().subscribe());
      }
    });
  }

}
